import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BACKEND_URL } from "../Config/Config";

const getUserDetails = () => {
  const userDetails = localStorage.getItem("userDetail");
  if (!userDetails) throw new Error("No user details found in localStorage");
  return JSON.parse(userDetails);
};

const editEndpoint = async ({ data }) => {
  const user = getUserDetails();
  const { forTestCase, ...endpointData } = data;
  const queryParams = new URLSearchParams({
    companyId: user.companyid,
  });
  if (forTestCase !== undefined) {
    queryParams.append("forTestCase", forTestCase.toString());
  }
  const response = await axios.put(
    `${API_BACKEND_URL}/endpoint/updateEndpointInfo?${queryParams.toString()}`,
    endpointData,
  );
  return response.data;
};

export const useEditEndpoint = (options = {}) => {
  return useMutation({
    mutationFn: editEndpoint,
    ...options,
  });
};
//update endpoint method, name, path..

const updateEndpoint = async ({ data }) => {
  console.log("dsfsdf");
  const response = await axios.put(
    `${API_BACKEND_URL}/endpoint/updateEndpoint?forTestCase=${data.forall}`,
    data,
  );
  return response.data;
};

export const useUpdateEndpoint = (options = {}) => {
  return useMutation({
    mutationFn: updateEndpoint,
    ...options,
  });
};

const reorderEndpoints = async ({ collectionId, endpointIds }) => {
  const response = await axios.put(`${API_BACKEND_URL}/endpoint/reorder`, {
    collectionId,
    endpointIds,
  });
  return response.data;
};

export const useReorderEndpoints = (options = {}) => {
  return useMutation({
    mutationFn: reorderEndpoints,
    ...options,
  });
};

const deleteEndpoint = async ({ endpointId }) => {
  const user = getUserDetails();

  const response = await axios.delete(
    `${API_BACKEND_URL}/endpoint/deleteEndpoint?companyId=${user.companyid}&endpointId=${endpointId}`,
  );
  return response.data;
};

export const useDeleteEndpoint = (options = {}) => {
  return useMutation({
    mutationFn: deleteEndpoint,
    ...options,
  });
};
